export const API_PREFIX = '/agent-api';
const buildUrl = (path: string) => `${API_PREFIX}${path}`;

const API = {
    marketplace: {
        list: buildUrl('/marketplace/list')
    },
    chat: {
        sessions: buildUrl('/chat/sessions'),
        execute: buildUrl('/chat/execute'),
        executeStream: buildUrl('/chat/execute/stream'),
        context: buildUrl('/chat/context'),
    },
    sources: {
        base: buildUrl('/sources'),
        statusBatch: buildUrl('/sources/status'),
        status: (sourceId: string) => buildUrl(`/sources/${sourceId}/status`),
    },
    materials: {
        base: buildUrl('/materials'),
        stats: buildUrl('/materials/stats'),
        dirStats: buildUrl('/materials/dir-stats'),
        dirs: buildUrl('/materials/dirs'),
        move: buildUrl('/materials/move'),
        copy: buildUrl('/materials/copy'),
        sync: buildUrl('/materials/sync'),
        file: (itemId: string) => buildUrl(`/materials/${itemId}/file`),
        /** 素材内容（cached_content / 提取文本 / ASR 文案） */
        content: (itemId: string) => buildUrl(`/materials/${itemId}/content`),
        /** 统一入库入口：云端转发 Java /mainD/material/record，桌面本地落库 */
        record: buildUrl('/materials/record'),
    },
    models: {
        base: buildUrl('/models'),
        defaults: buildUrl('/models/defaults'),
        providers: buildUrl('/models/providers'),
        providerSettings: buildUrl('/models/providers/settings'),
        syncFishownapiKey: buildUrl('/models/providers/fishownapi/sync-key'),
    },
    comfyui: {
        workflows: buildUrl('/comfyui/workflows'),
        workflow: (workflowId: string) => buildUrl(`/comfyui/workflows/${workflowId}`),
    },
    notebooks: {
        base: buildUrl('/notebooks'),
    },
    notes: {
        base: buildUrl('/notes'),
    },
    insights: {
        base: buildUrl('/insights'),
    },
    skills: {
        base: buildUrl('/skills'),
    },
    embed: {
        base: buildUrl('/embed'),
    },
    embeddings: {
        rebuild: buildUrl('/embeddings/rebuild'),
    },
    search: {
        base: buildUrl('/search'),
        ask: buildUrl('/search/ask'),
    },
    settings: {
        base: buildUrl('/settings'),
    },
    graphrag: {
        corpusState: buildUrl('/graphrag/corpus/state'),
        chatStream: buildUrl('/graphrag/chat/stream'),
        corpusFile: buildUrl('/graphrag/corpus/file'),
        corpusUpload: buildUrl('/graphrag/corpus/upload'),
        corpusLogs: buildUrl('/graphrag/corpus/logs'),
        corpusIndexStop: buildUrl('/graphrag/corpus/index/stop'),
        corpusArchiveList: buildUrl('/graphrag/corpus/archive/list'),
        corpusArchiveCreate: buildUrl('/graphrag/corpus/archive/create'),
        corpusArchiveRestore: buildUrl('/graphrag/corpus/archive/restore'),
        corpusArchiveRename: buildUrl('/graphrag/corpus/archive/rename'),
        corpusArchiveDelete: buildUrl('/graphrag/corpus/archive/delete'),
        corpusKgRename: buildUrl('/graphrag/corpus/kg/rename'),
        corpusRemove: buildUrl('/graphrag/corpus/remove'),
        indexStream: buildUrl('/graphrag/index/stream'),
        data: buildUrl('/graphrag/data'),
        window: buildUrl('/graphrag/window'),
        query: buildUrl('/graphrag/query'),
        asset: buildUrl('/graphrag/asset'),
        contentList: buildUrl('/graphrag/content-list'),
        retrySource: buildUrl('/graphrag/retry-source'),
        build: buildUrl('/graphrag/build'),
    },
    commands: {
        jobs: buildUrl('/commands/jobs')
    },
    shortDrama: {
        base: buildUrl('/short-drama'),
        projects: buildUrl('/short-drama/projects')
    }
};

export default API;
